// extracted by mini-css-extract-plugin
export default {"view":"Shirt_view__lWXCK","shirtCnt":"Shirt_shirtCnt__9x-NT","icon":"Shirt_icon__gbNxU","number":"Shirt_number__cBaFs","age":"Shirt_age__FBESQ"};